import { HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { JsonHttpService } from '../../shared/http/json-http.service';
import { InitStep, InitStepArtifactInfo } from '../models/init-step';

@Injectable({
    providedIn: 'root'
})
export class InitializeService {
    private httpService = inject(JsonHttpService);

    getInitSteps(): Promise<InitStep[]> {
        return firstValueFrom(this.httpService.getTyped<InitStep[]>('/api/distribution/initialize/get-init-steps'));
    }

    deleteInitStep(initStepId: number): Promise<void> {
        const options = { params: new HttpParams().set('id', `${initStepId}`) };
        return firstValueFrom(this.httpService.get('/api/distribution/initialize/delete-init-step', options, false));
    }

    saveInitStep(initStep: InitStep): Promise<InitStep> {
        return firstValueFrom(this.httpService.post('/api/distribution/initialize/save-init-step', initStep));
    }

    getInitStepArtifactInfo(artifactId: string): Promise<InitStepArtifactInfo> {
        const options = { params: new HttpParams().set('artifactId', `${artifactId}`) };
        return firstValueFrom(this.httpService.get('/api/distribution/initialize/get-init-step-artifact-info', options));
    }

    getInitConfigInitStepDisplayGroups(initStepId: number, jsonConfig?: string) {
        const options = { params: new HttpParams().set('initStepId', `${initStepId}`) };
        const data = jsonConfig ? JSON.stringify(jsonConfig) : '';
        return firstValueFrom(this.httpService.post('/api/distribution/initialize/get-init-configuration-initstep-display-groups', data, options));
    }
}
